/**
 * @generated SignedSource<<6feaef03708212a23da1f24677bcfaf9>>
 * @relayHash be2fa6578edc7674494b3b15352c2da5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c87dc483b646067310ffb71a20f2a44bc95f5eac4ea747c3f0a2c40f77ba4dfd

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type JiraIssueSearchFieldSetsInput = {
  fieldSetIds?: ReadonlyArray<string> | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type JiraIssueSearchViewInput = {
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  filterId?: string | null | undefined;
  namespace?: string | null | undefined;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchOptions = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type JiraIssueSearchStaticViewInput = {
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchViewConfigInput = {
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewInput?: JiraIssueSearchViewInput | null | undefined;
};
export type IssueNavigatorIssueSearchRefetchQuery$variables = {
  after?: string | null | undefined;
  amountOfColumns?: number | null | undefined;
  before?: string | null | undefined;
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  fieldSetsContext?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  fieldSetsInput?: JiraIssueSearchFieldSetsInput | null | undefined;
  filterId?: string | null | undefined;
  first?: number | null | undefined;
  groupBy?: string | null | undefined;
  isPaginating: boolean;
  isRefactorNinToViewSchemaEnabled: boolean;
  issueSearchInput: JiraIssueSearchInput;
  last?: number | null | undefined;
  namespace?: string | null | undefined;
  options?: JiraIssueSearchOptions | null | undefined;
  projectKey?: string | null | undefined;
  projectKeys?: ReadonlyArray<string> | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
  shouldQueryFieldSetsById: boolean;
  shouldQueryHasChildren: boolean;
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewConfigInput?: JiraIssueSearchViewConfigInput | null | undefined;
  viewId?: string | null | undefined;
};
export type IssueNavigatorIssueSearchRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigator_refetchQueryNew">;
};
export type IssueNavigatorIssueSearchRefetchQuery = {
  response: IssueNavigatorIssueSearchRefetchQuery$data;
  variables: IssueNavigatorIssueSearchRefetchQuery$variables;
};
({
  "isRefactorNinToViewSchemaEnabled": isRefactorNinToViewSchemaEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": isRefactorNinToViewSchemaEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": bulkOpsInNinEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
  readonly isRefactorNinToViewSchemaEnabled: {
    readonly get: () => boolean;
  };
});

import bulkOpsInNinEnabled_provider from '@atlassian/jira-relay-provider/src/is-bulk-ops-in-nin-enabled.relayprovider';
import isJscInfiniteScrollEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-infinite-scroll-enabled.relayprovider';
import isRefactorNinToViewSchemaEnabled_provider from '@atlassian/jira-relay-provider/src/is-refactor-nin-to-view-schema-enabled.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsContext"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPaginating"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRefactorNinToViewSchemaEnabled"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "options"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKeys"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldSetsById"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryHasChildren"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewConfigInput"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v24 = {
  "kind": "Variable",
  "name": "projectKey",
  "variableName": "projectKey"
},
v25 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v26 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v27 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v28 = {
  "kind": "Variable",
  "name": "fieldSetsInput",
  "variableName": "fieldSetsInput"
},
v29 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v30 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v31 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v32 = {
  "kind": "Variable",
  "name": "options",
  "variableName": "options"
},
v33 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v34 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
},
v35 = [
  (v25/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/)
],
v36 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v37 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v38 = {
  "kind": "ScalarField",
  "name": "id"
},
v39 = {
  "kind": "ScalarField",
  "name": "key"
},
v40 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v41 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v42 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v43 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v44 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    (v38/*: any*/)
  ]
},
v45 = {
  "kind": "InlineFragment",
  "selections": [
    (v42/*: any*/),
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v44/*: any*/),
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v46 = {
  "args": [
    {
      "kind": "Literal",
      "name": "ids",
      "value": [
        "status"
      ]
    }
  ],
  "concreteType": "JiraIssueFieldConnection",
  "kind": "LinkedField",
  "name": "fieldsById",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueFieldEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v37/*: any*/),
            (v45/*: any*/),
            (v38/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "fieldsById(ids:[\"status\"])"
},
v47 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v48 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v47/*: any*/),
        (v38/*: any*/)
      ]
    },
    (v38/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "__id"
},
v50 = {
  "kind": "ClientExtension",
  "selections": [
    (v49/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isHighlightedIssueRow"
    }
  ]
},
v51 = {
  "kind": "Variable",
  "name": "filterId",
  "variableName": "filterId"
},
v52 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "amountOfColumns"
},
v53 = {
  "kind": "Variable",
  "name": "namespace",
  "variableName": "namespace"
},
v54 = {
  "kind": "Variable",
  "name": "viewId",
  "variableName": "viewId"
},
v55 = [
  {
    "kind": "Variable",
    "name": "context",
    "variableName": "fieldSetsContext"
  },
  (v51/*: any*/),
  (v52/*: any*/),
  (v53/*: any*/),
  (v54/*: any*/)
],
v56 = {
  "kind": "ScalarField",
  "name": "text"
},
v57 = {
  "kind": "ScalarField",
  "name": "name"
},
v58 = {
  "kind": "ScalarField",
  "name": "picture"
},
v59 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
},
v60 = {
  "kind": "ScalarField",
  "name": "type"
},
v61 = {
  "kind": "ScalarField",
  "name": "fieldSetId"
},
v62 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isJiraIssueField"
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraAffectedServiceConnection",
      "kind": "LinkedField",
      "name": "selectedAffectedServicesConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAffectedServiceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraAffectedService",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "serviceId"
                },
                (v57/*: any*/),
                (v38/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraAffectedServicesField"
},
v64 = {
  "kind": "ScalarField",
  "name": "value"
},
v65 = [
  (v64/*: any*/),
  (v38/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v66 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v67 = {
  "kind": "ClientExtension",
  "selections": [
    (v66/*: any*/)
  ]
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "JiraCascadingOption",
      "kind": "LinkedField",
      "name": "cascadingOption",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "parentOptionValue",
          "plural": false,
          "selections": (v65/*: any*/)
        },
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "childOptionValue",
          "plural": false,
          "selections": (v65/*: any*/)
        }
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraCascadingSelectField"
},
v69 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v70 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v71 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v72 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "args": (v69/*: any*/),
      "concreteType": "JiraComponentConnection",
      "kind": "LinkedField",
      "name": "selectedComponentsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraComponent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v70/*: any*/),
                (v71/*: any*/),
                (v38/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedComponentsConnection(first:1000)"
    },
    (v67/*: any*/)
  ],
  "type": "JiraComponentsField"
},
v73 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v74 = {
  "kind": "InlineFragment",
  "selections": [
    (v73/*: any*/),
    (v57/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    (v56/*: any*/),
    (v57/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v76 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canAddComment"
        },
        (v76/*: any*/)
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "kind": "ScalarField",
      "name": "uri"
    },
    (v67/*: any*/)
  ],
  "type": "JiraUrlField"
},
v79 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v38/*: any*/)
  ]
},
v80 = [
  (v79/*: any*/)
],
v81 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v82 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "fieldOptions",
      "plural": false,
      "selections": [
        (v76/*: any*/)
      ]
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        (v64/*: any*/),
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v80/*: any*/)
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v80/*: any*/)
        },
        (v38/*: any*/),
        (v81/*: any*/)
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraSingleSelectField"
},
v83 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v38/*: any*/),
                (v64/*: any*/),
                (v81/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraMultipleSelectField"
},
v84 = {
  "concreteType": "JiraOption",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v64/*: any*/)
  ]
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "JiraOptionConnection",
      "kind": "LinkedField",
      "name": "selectedOptions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraOptionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            (v84/*: any*/)
          ]
        }
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraCheckboxesField"
},
v86 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v87 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v88 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "JiraUserConnection",
      "kind": "LinkedField",
      "name": "selectedUsersConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraUserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v37/*: any*/),
                (v86/*: any*/),
                (v57/*: any*/),
                (v58/*: any*/),
                (v38/*: any*/),
                (v87/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "email"
                    }
                  ],
                  "type": "AtlassianAccountUser"
                }
              ]
            }
          ]
        }
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraMultipleSelectUserPickerField"
},
v89 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "JiraTeamView",
      "kind": "LinkedField",
      "name": "selectedTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedId"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedName"
        }
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraTeamViewField"
},
v90 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTimeTrackingField",
          "kind": "LinkedField",
          "name": "timeTrackingField",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            {
              "concreteType": "JiraEstimate",
              "kind": "LinkedField",
              "name": "originalEstimate",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "timeInSeconds"
                }
              ]
            },
            {
              "concreteType": "JiraTimeTrackingSettings",
              "kind": "LinkedField",
              "name": "timeTrackingSettings",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "workingHoursPerDay"
                },
                {
                  "kind": "ScalarField",
                  "name": "workingDaysPerWeek"
                },
                {
                  "kind": "ScalarField",
                  "name": "defaultFormat"
                },
                {
                  "kind": "ScalarField",
                  "name": "defaultUnit"
                }
              ]
            },
            (v42/*: any*/),
            (v57/*: any*/),
            (v60/*: any*/),
            (v67/*: any*/)
          ]
        },
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraOriginalTimeEstimateField"
},
v91 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "selectedOption",
      "plural": false,
      "selections": [
        {
          "alias": "label",
          "kind": "ScalarField",
          "name": "value"
        },
        (v38/*: any*/),
        (v70/*: any*/)
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraRadioSelectField"
},
v92 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "args": (v69/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v38/*: any*/),
                (v57/*: any*/),
                (v70/*: any*/),
                (v71/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "versionId"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    },
    (v67/*: any*/)
  ],
  "type": "JiraMultipleVersionPickerField"
},
v93 = [
  (v38/*: any*/)
],
v94 = {
  "kind": "ClientExtension",
  "selections": [
    (v49/*: any*/)
  ]
},
v95 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": (v93/*: any*/)
    },
    {
      "args": (v69/*: any*/),
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v38/*: any*/),
                (v39/*: any*/)
              ]
            }
          ]
        },
        (v94/*: any*/)
      ],
      "storageKey": "selectedGoals(first:1000)"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        (v49/*: any*/),
        (v66/*: any*/)
      ]
    }
  ],
  "type": "JiraGoalsField"
},
v96 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "args": (v69/*: any*/),
      "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
      "kind": "LinkedField",
      "name": "confluenceRemoteIssueLinks",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v38/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "href"
                }
              ]
            }
          ]
        },
        (v76/*: any*/)
      ],
      "storageKey": "confluenceRemoteIssueLinks(first:1000)"
    },
    (v67/*: any*/)
  ],
  "type": "JiraConfluenceRemoteIssueLinksField"
},
v97 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v68/*: any*/),
    (v72/*: any*/),
    (v74/*: any*/),
    (v75/*: any*/),
    (v77/*: any*/),
    (v78/*: any*/),
    (v82/*: any*/),
    (v83/*: any*/),
    (v85/*: any*/),
    (v88/*: any*/),
    (v89/*: any*/),
    (v90/*: any*/),
    (v91/*: any*/),
    (v92/*: any*/),
    (v95/*: any*/),
    (v96/*: any*/)
  ]
},
v98 = {
  "kind": "ScalarField",
  "name": "message"
},
v99 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraCmdbObjectConnection",
      "kind": "LinkedField",
      "name": "selectedCmdbObjectsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraCmdbObjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraCmdbObject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "objectId"
                },
                {
                  "kind": "ScalarField",
                  "name": "label"
                },
                {
                  "concreteType": "JiraCmdbAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraCmdbMediaClientConfig",
                      "kind": "LinkedField",
                      "name": "mediaClientConfig",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "clientId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fileId"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaBaseUrl"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "mediaJwtToken"
                        }
                      ]
                    },
                    {
                      "kind": "ScalarField",
                      "name": "url48"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            (v98/*: any*/)
          ]
        }
      ]
    }
  ],
  "type": "JiraCMDBField"
},
v100 = [
  (v57/*: any*/),
  (v38/*: any*/)
],
v101 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "componentsOld",
      "concreteType": "JiraComponentConnection",
      "kind": "LinkedField",
      "name": "selectedComponentsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraComponentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraComponent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v100/*: any*/)
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraComponentsField"
},
v102 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    (v101/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v56/*: any*/)
      ],
      "type": "JiraSingleLineTextField"
    }
  ]
},
v103 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v104 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "date"
    },
    (v57/*: any*/),
    (v103/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v105 = {
  "kind": "InlineFragment",
  "selections": [
    (v73/*: any*/)
  ],
  "type": "JiraDateTimePickerField"
},
v106 = {
  "kind": "ScalarField",
  "name": "summary"
},
v107 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraEpic",
      "kind": "LinkedField",
      "name": "epic",
      "plural": false,
      "selections": [
        (v39/*: any*/),
        (v106/*: any*/),
        {
          "kind": "ScalarField",
          "name": "color"
        },
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraEpicLinkField"
},
v108 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "renderedFieldHtml"
    }
  ],
  "type": "JiraFallbackField"
},
v109 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        (v57/*: any*/),
        (v43/*: any*/),
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusCategoryField"
},
v110 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        (v57/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusId"
        },
        (v44/*: any*/),
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraStatusField"
},
v111 = [
  (v57/*: any*/)
],
v112 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v69/*: any*/),
      "concreteType": "JiraLabelConnection",
      "kind": "LinkedField",
      "name": "selectedLabelsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraLabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraLabel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v111/*: any*/)
            }
          ]
        },
        (v76/*: any*/)
      ],
      "storageKey": "selectedLabelsConnection(first:1000)"
    },
    (v57/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraLabelsField"
},
v113 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v59/*: any*/),
        (v57/*: any*/),
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraIssueTypeField"
},
v114 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    (v38/*: any*/)
  ]
},
v115 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v79/*: any*/),
    (v38/*: any*/)
  ]
},
v116 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v117 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v116/*: any*/),
        (v57/*: any*/),
        (v38/*: any*/)
      ]
    },
    (v38/*: any*/)
  ]
},
v118 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v119 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        (v39/*: any*/),
        (v114/*: any*/),
        (v38/*: any*/)
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v39/*: any*/),
            (v115/*: any*/),
            (v117/*: any*/),
            (v114/*: any*/),
            (v38/*: any*/)
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "parentIssue",
          "plural": false,
          "selections": [
            (v39/*: any*/),
            (v115/*: any*/),
            (v117/*: any*/),
            (v114/*: any*/),
            (v38/*: any*/),
            (v40/*: any*/),
            (v118/*: any*/),
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "summary",
                    "issuetype",
                    "status"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v37/*: any*/),
                        (v38/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v42/*: any*/),
                            (v56/*: any*/)
                          ],
                          "type": "JiraSingleLineTextField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v42/*: any*/),
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "issueTypeId"
                                },
                                (v57/*: any*/),
                                (v116/*: any*/),
                                (v47/*: any*/),
                                (v38/*: any*/)
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        (v45/*: any*/)
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
            }
          ]
        },
        (v57/*: any*/),
        (v67/*: any*/)
      ]
    }
  ],
  "type": "JiraParentIssueField"
},
v120 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v121 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        (v57/*: any*/),
        (v120/*: any*/),
        (v38/*: any*/)
      ]
    },
    (v57/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraPriorityField"
},
v122 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v57/*: any*/),
        (v39/*: any*/),
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "large"
            }
          ]
        },
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraProjectField"
},
v123 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraResolution",
      "kind": "LinkedField",
      "name": "resolution",
      "plural": false,
      "selections": (v100/*: any*/)
    }
  ],
  "type": "JiraResolutionField"
},
v124 = {
  "kind": "ScalarField",
  "name": "sprintId"
},
v125 = {
  "kind": "ScalarField",
  "name": "state"
},
v126 = {
  "kind": "ScalarField",
  "name": "endDate"
},
v127 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraSprintConnection",
      "kind": "LinkedField",
      "name": "selectedSprintsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraSprintEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v38/*: any*/),
                (v124/*: any*/),
                (v57/*: any*/),
                (v125/*: any*/),
                (v126/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v57/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraSprintField"
},
v128 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v37/*: any*/),
        (v86/*: any*/),
        (v58/*: any*/),
        (v57/*: any*/),
        (v38/*: any*/),
        (v87/*: any*/)
      ]
    },
    (v57/*: any*/),
    (v103/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraSingleSelectUserPickerField"
},
v129 = {
  "kind": "InlineFragment",
  "selections": [
    (v57/*: any*/),
    {
      "args": (v69/*: any*/),
      "concreteType": "JiraVersionConnection",
      "kind": "LinkedField",
      "name": "selectedVersionsConnection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v100/*: any*/)
            }
          ]
        }
      ],
      "storageKey": "selectedVersionsConnection(first:1000)"
    }
  ],
  "type": "JiraMultipleVersionPickerField"
},
v130 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraRichText",
      "kind": "LinkedField",
      "name": "richText",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraADF",
          "kind": "LinkedField",
          "name": "adfValue",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraAdfToConvertedPlainText",
              "kind": "LinkedField",
              "name": "convertedPlainText",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "plainText"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraRichTextField"
},
v131 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        (v57/*: any*/),
        (v116/*: any*/),
        (v38/*: any*/)
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
},
v132 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "JiraIssueLinkConnection",
      "kind": "LinkedField",
      "name": "issueLinkConnection",
      "plural": false,
      "selections": [
        (v76/*: any*/),
        {
          "concreteType": "JiraIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    (v118/*: any*/),
                    (v39/*: any*/),
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "ids",
                          "value": [
                            "statusCategory"
                          ]
                        }
                      ],
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fieldsById",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v37/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v44/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v38/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                    },
                    (v38/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "relationName"
                },
                (v38/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "issueLinkConnection(first:1)"
    }
  ],
  "type": "JiraIssueLinkField"
},
v133 = {
  "kind": "ScalarField",
  "name": "number"
},
v134 = [
  (v133/*: any*/)
],
v135 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStoryPointField"
    },
    (v133/*: any*/),
    (v57/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": (v134/*: any*/)
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v133/*: any*/),
        (v57/*: any*/),
        (v67/*: any*/)
      ]
    },
    (v67/*: any*/)
  ],
  "type": "JiraNumberField"
},
v136 = [
  {
    "concreteType": "JiraIssueFieldSetEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraIssueFieldSet",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v60/*: any*/),
          (v61/*: any*/),
          {
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fields",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v37/*: any*/),
                      (v42/*: any*/),
                      (v60/*: any*/),
                      (v62/*: any*/),
                      (v38/*: any*/),
                      (v63/*: any*/),
                      (v97/*: any*/),
                      (v99/*: any*/),
                      (v102/*: any*/),
                      (v104/*: any*/),
                      (v105/*: any*/),
                      (v107/*: any*/),
                      (v108/*: any*/),
                      (v75/*: any*/),
                      (v109/*: any*/),
                      (v110/*: any*/),
                      (v112/*: any*/),
                      (v113/*: any*/),
                      (v119/*: any*/),
                      (v121/*: any*/),
                      (v122/*: any*/),
                      (v123/*: any*/),
                      (v127/*: any*/),
                      (v128/*: any*/),
                      (v129/*: any*/),
                      (v130/*: any*/),
                      (v131/*: any*/),
                      (v132/*: any*/),
                      (v135/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v137 = {
  "condition": "shouldQueryFieldSetsById",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fieldSetIds",
          "variableName": "fieldSetIds"
        },
        (v52/*: any*/)
      ],
      "concreteType": "JiraIssueFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSetsById",
      "plural": false,
      "selections": (v136/*: any*/)
    }
  ]
},
v138 = {
  "kind": "InlineFragment",
  "selections": [
    (v60/*: any*/),
    (v67/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v139 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v41/*: any*/),
    (v46/*: any*/),
    (v48/*: any*/),
    (v50/*: any*/),
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": (v55/*: any*/),
          "concreteType": "JiraIssueFieldSetConnection",
          "kind": "LinkedField",
          "name": "fieldSetsForIssueSearchView",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueFieldSetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fields",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v37/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v42/*: any*/),
                                    (v56/*: any*/),
                                    (v57/*: any*/)
                                  ],
                                  "type": "JiraSingleLineTextField"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v42/*: any*/),
                                    (v57/*: any*/),
                                    {
                                      "kind": "LinkedField",
                                      "name": "user",
                                      "plural": false,
                                      "selections": [
                                        (v37/*: any*/),
                                        (v57/*: any*/),
                                        (v58/*: any*/),
                                        (v38/*: any*/)
                                      ]
                                    }
                                  ],
                                  "type": "JiraSingleSelectUserPickerField"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v42/*: any*/),
                                    {
                                      "concreteType": "JiraIssueType",
                                      "kind": "LinkedField",
                                      "name": "issueType",
                                      "plural": false,
                                      "selections": [
                                        (v57/*: any*/),
                                        (v59/*: any*/),
                                        (v38/*: any*/)
                                      ]
                                    }
                                  ],
                                  "type": "JiraIssueTypeField"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v42/*: any*/),
                                    (v44/*: any*/)
                                  ],
                                  "type": "JiraStatusCategoryField"
                                },
                                (v38/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        (v137/*: any*/),
        {
          "condition": "shouldQueryFieldSetsById",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "args": (v55/*: any*/),
              "concreteType": "JiraIssueFieldSetConnection",
              "kind": "LinkedField",
              "name": "fieldSetsForIssueSearchView",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldSetEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldSet",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v60/*: any*/),
                        (v61/*: any*/),
                        {
                          "concreteType": "JiraIssueFieldConnection",
                          "kind": "LinkedField",
                          "name": "fields",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "JiraIssueFieldEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v42/*: any*/),
                                    (v60/*: any*/),
                                    (v62/*: any*/),
                                    (v63/*: any*/),
                                    {
                                      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                      "kind": "Condition",
                                      "passingValue": true,
                                      "selections": [
                                        (v68/*: any*/),
                                        (v72/*: any*/),
                                        (v74/*: any*/),
                                        (v138/*: any*/),
                                        (v77/*: any*/),
                                        (v78/*: any*/),
                                        (v82/*: any*/),
                                        (v83/*: any*/),
                                        (v85/*: any*/),
                                        (v88/*: any*/),
                                        (v89/*: any*/),
                                        (v90/*: any*/),
                                        (v91/*: any*/),
                                        (v92/*: any*/),
                                        (v95/*: any*/),
                                        (v96/*: any*/)
                                      ]
                                    },
                                    (v99/*: any*/),
                                    {
                                      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                      "kind": "Condition",
                                      "passingValue": false,
                                      "selections": [
                                        (v101/*: any*/)
                                      ]
                                    },
                                    (v104/*: any*/),
                                    (v105/*: any*/),
                                    (v107/*: any*/),
                                    (v108/*: any*/),
                                    (v138/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "concreteType": "JiraStatusCategory",
                                          "kind": "LinkedField",
                                          "name": "statusCategory",
                                          "plural": false,
                                          "selections": (v111/*: any*/)
                                        }
                                      ],
                                      "type": "JiraStatusCategoryField"
                                    },
                                    (v110/*: any*/),
                                    (v112/*: any*/),
                                    (v119/*: any*/),
                                    (v121/*: any*/),
                                    (v122/*: any*/),
                                    (v123/*: any*/),
                                    (v127/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        (v60/*: any*/),
                                        {
                                          "kind": "LinkedField",
                                          "name": "user",
                                          "plural": false,
                                          "selections": [
                                            (v86/*: any*/),
                                            (v87/*: any*/)
                                          ]
                                        },
                                        (v103/*: any*/),
                                        (v67/*: any*/)
                                      ],
                                      "type": "JiraSingleSelectUserPickerField"
                                    },
                                    (v129/*: any*/),
                                    (v130/*: any*/),
                                    (v131/*: any*/),
                                    (v132/*: any*/),
                                    (v135/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v106/*: any*/),
        {
          "concreteType": "JiraIssueTypeField",
          "kind": "LinkedField",
          "name": "issueTypeField",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "issueType",
              "plural": false,
              "selections": [
                (v59/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v140 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v141 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": (v140/*: any*/),
      "concreteType": "JiraIssueFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSets",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueFieldSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v60/*: any*/),
                (v61/*: any*/),
                {
                  "concreteType": "JiraIssueFieldConnection",
                  "kind": "LinkedField",
                  "name": "fields",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v37/*: any*/),
                            (v42/*: any*/),
                            (v60/*: any*/),
                            (v62/*: any*/),
                            (v38/*: any*/),
                            (v63/*: any*/),
                            (v97/*: any*/),
                            (v99/*: any*/),
                            (v102/*: any*/),
                            (v104/*: any*/),
                            (v105/*: any*/),
                            (v107/*: any*/),
                            (v108/*: any*/),
                            (v75/*: any*/),
                            (v109/*: any*/),
                            (v110/*: any*/),
                            (v112/*: any*/),
                            (v113/*: any*/),
                            (v119/*: any*/),
                            (v121/*: any*/),
                            (v122/*: any*/),
                            (v123/*: any*/),
                            (v127/*: any*/),
                            (v128/*: any*/),
                            (v129/*: any*/),
                            (v130/*: any*/),
                            (v131/*: any*/),
                            (v132/*: any*/),
                            (v135/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraOptionConnection",
                                  "kind": "LinkedField",
                                  "name": "selectedOptions",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "JiraOptionEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        (v84/*: any*/),
                                        (v94/*: any*/)
                                      ]
                                    }
                                  ]
                                }
                              ],
                              "type": "JiraCheckboxesField"
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "concreteType": "JiraOption",
                                  "kind": "LinkedField",
                                  "name": "fieldOption",
                                  "plural": false,
                                  "selections": [
                                    (v81/*: any*/),
                                    (v38/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraSingleSelectField"
                            },
                            (v94/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "fieldSets(first:500)"
    }
  ]
},
v142 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v143 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v144 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v142/*: any*/),
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    (v143/*: any*/),
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    }
  ]
},
v145 = {
  "concreteType": "JiraIssueNavigatorPageInfo",
  "kind": "LinkedField",
  "name": "issueNavigatorPageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "firstIssuePosition"
    },
    {
      "kind": "ScalarField",
      "name": "lastIssuePosition"
    }
  ]
},
v146 = {
  "kind": "ScalarField",
  "name": "pageNumber"
},
v147 = {
  "kind": "ScalarField",
  "name": "isCurrent"
},
v148 = [
  (v146/*: any*/),
  (v36/*: any*/),
  (v147/*: any*/)
],
v149 = {
  "args": [
    {
      "kind": "Literal",
      "name": "maxCursors",
      "value": 7
    }
  ],
  "concreteType": "JiraPageCursors",
  "kind": "LinkedField",
  "name": "pageCursors",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "around",
      "plural": true,
      "selections": (v148/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "last",
      "plural": false,
      "selections": (v148/*: any*/)
    },
    {
      "concreteType": "JiraPageCursor",
      "kind": "LinkedField",
      "name": "first",
      "plural": false,
      "selections": [
        (v36/*: any*/),
        (v146/*: any*/),
        (v147/*: any*/)
      ]
    }
  ],
  "storageKey": "pageCursors(maxCursors:7)"
},
v150 = {
  "kind": "ScalarField",
  "name": "totalIssueSearchResultCount"
},
v151 = {
  "kind": "LinkedField",
  "name": "issueSearchError",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "messages"
        }
      ],
      "type": "JiraInvalidJqlError"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v98/*: any*/),
        {
          "kind": "ScalarField",
          "name": "errorType"
        }
      ],
      "type": "JiraInvalidSyntaxError"
    }
  ]
},
v152 = {
  "kind": "ScalarField",
  "name": "jql"
},
v153 = {
  "kind": "ScalarField",
  "name": "isCappingIssueSearchResult"
},
v154 = {
  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "args": (v140/*: any*/),
          "concreteType": "JiraIssueFieldSetConnection",
          "kind": "LinkedField",
          "name": "fieldSets",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueFieldSetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldSet",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraIssueFieldConnection",
                      "kind": "LinkedField",
                      "name": "fields",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "JiraIssueFieldEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v42/*: any*/),
                                (v37/*: any*/),
                                (v60/*: any*/),
                                (v38/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "storageKey": "fieldSets(first:500)"
        }
      ]
    }
  ]
},
v155 = [
  {
    "concreteType": "JiraIssueEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v36/*: any*/),
      (v139/*: any*/),
      (v37/*: any*/),
      {
        "condition": "shouldQueryHasChildren",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "filterByProjectKeys",
                "variableName": "projectKeys"
              }
            ],
            "kind": "ScalarField",
            "name": "hasChildren"
          },
          {
            "args": [
              (v24/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "canHaveChildIssues"
          }
        ]
      },
      (v94/*: any*/),
      (v141/*: any*/)
    ]
  },
  (v144/*: any*/),
  (v145/*: any*/),
  (v149/*: any*/),
  (v150/*: any*/),
  (v151/*: any*/),
  (v152/*: any*/),
  (v153/*: any*/),
  (v94/*: any*/),
  (v154/*: any*/)
],
v156 = [
  "issueSearchInput"
],
v157 = {
  "kind": "ScalarField",
  "name": "viewId"
},
v158 = {
  "kind": "Variable",
  "name": "staticViewInput",
  "variableName": "staticViewInput"
},
v159 = [
  (v158/*: any*/)
],
v160 = {
  "kind": "ScalarField",
  "name": "isHierarchyEnabled"
},
v161 = {
  "kind": "ScalarField",
  "name": "hideDone"
},
v162 = {
  "kind": "ScalarField",
  "name": "hasDefaultFieldSets"
},
v163 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "fieldSetSelectedState": "SELECTED"
    }
  },
  (v52/*: any*/)
],
v164 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v165 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v166 = {
  "kind": "ScalarField",
  "name": "isSortable"
},
v167 = {
  "concreteType": "JiraFieldSetPreferences",
  "kind": "LinkedField",
  "name": "fieldSetPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "width"
    }
  ]
},
v168 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isPlaceHolderField"
    }
  ]
},
v169 = {
  "concreteType": "JiraFieldType",
  "kind": "LinkedField",
  "name": "fieldType",
  "plural": false,
  "selections": [
    (v164/*: any*/)
  ]
},
v170 = {
  "args": (v159/*: any*/),
  "concreteType": "JiraIssueSearchViewConfigSettings",
  "kind": "LinkedField",
  "name": "viewConfigSettings",
  "plural": false,
  "selections": [
    (v161/*: any*/)
  ]
},
v171 = {
  "kind": "ScalarField",
  "name": "canEnableHierarchy"
},
v172 = {
  "kind": "Variable",
  "name": "groupBy",
  "variableName": "groupBy"
},
v173 = [
  (v172/*: any*/),
  (v30/*: any*/),
  (v158/*: any*/)
],
v174 = {
  "concreteType": "JiraSpreadsheetGroupByConfig",
  "kind": "LinkedField",
  "name": "groupByConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraField",
      "kind": "LinkedField",
      "name": "groupByField",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        (v38/*: any*/)
      ]
    }
  ]
},
v175 = {
  "kind": "ScalarField",
  "name": "isGroupingEnabled"
},
v176 = {
  "kind": "ScalarField",
  "name": "canEnableGrouping"
},
v177 = [
  (v160/*: any*/),
  (v171/*: any*/),
  (v175/*: any*/),
  (v176/*: any*/)
],
v178 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "args": (v173/*: any*/),
      "concreteType": "JiraIssueSearchViewConfigSettings",
      "kind": "LinkedField",
      "name": "viewSettings",
      "plural": false,
      "selections": (v177/*: any*/)
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
},
v179 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v37/*: any*/),
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ]
},
v180 = [
  (v179/*: any*/),
  (v98/*: any*/)
],
v181 = [
  (v25/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/)
],
v182 = [
  (v25/*: any*/),
  (v26/*: any*/),
  (v29/*: any*/),
  (v172/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v33/*: any*/)
],
v183 = {
  "kind": "ScalarField",
  "name": "fieldType"
},
v184 = {
  "kind": "LinkedField",
  "name": "fieldValue",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraPriority",
          "kind": "LinkedField",
          "name": "priority",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "priorityId"
            },
            (v38/*: any*/),
            (v120/*: any*/),
            (v57/*: any*/)
          ]
        },
        (v164/*: any*/)
      ],
      "type": "JiraJqlPriorityFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v37/*: any*/),
            (v86/*: any*/),
            (v38/*: any*/),
            (v58/*: any*/),
            (v57/*: any*/)
          ]
        },
        (v164/*: any*/)
      ],
      "type": "JiraJqlUserFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            (v57/*: any*/),
            {
              "concreteType": "JiraStatusCategory",
              "kind": "LinkedField",
              "name": "statusCategory",
              "plural": false,
              "selections": [
                (v38/*: any*/),
                (v43/*: any*/)
              ]
            }
          ]
        },
        (v164/*: any*/),
        (v44/*: any*/)
      ],
      "type": "JiraJqlStatusFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": (v134/*: any*/),
      "type": "JiraJqlNumberFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraOption",
          "kind": "LinkedField",
          "name": "option",
          "plural": false,
          "selections": [
            (v81/*: any*/),
            (v38/*: any*/),
            (v79/*: any*/),
            (v64/*: any*/)
          ]
        },
        (v164/*: any*/)
      ],
      "type": "JiraJqlOptionFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraSprint",
          "kind": "LinkedField",
          "name": "sprint",
          "plural": false,
          "selections": [
            (v124/*: any*/),
            (v38/*: any*/),
            (v125/*: any*/),
            (v57/*: any*/),
            (v126/*: any*/)
          ]
        },
        (v164/*: any*/)
      ],
      "type": "JiraJqlSprintFieldValue"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraGoal",
          "kind": "LinkedField",
          "name": "goal",
          "plural": false,
          "selections": [
            (v38/*: any*/),
            {
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "kind": "ScalarField",
              "name": "score"
            }
          ]
        },
        (v164/*: any*/)
      ],
      "type": "JiraJqlGoalsFieldValue"
    }
  ]
},
v185 = {
  "kind": "ScalarField",
  "name": "issueCount"
},
v186 = [
  (v28/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v187 = [
  (v25/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueNavigatorIssueSearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v24/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKeys",
            "variableName": "projectKeys"
          }
        ],
        "kind": "FragmentSpread",
        "name": "main_issueNavigator_IssueNavigator_refetchQueryNew"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "IssueNavigatorIssueSearchRefetchQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v35/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "issueSearch",
                "plural": false,
                "selections": (v155/*: any*/)
              },
              {
                "args": (v35/*: any*/),
                "filters": (v156/*: any*/),
                "handle": "connection",
                "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                "kind": "LinkedHandle",
                "name": "issueSearch"
              },
              {
                "args": [
                  (v27/*: any*/),
                  (v51/*: any*/),
                  (v30/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "issueSearchViewResult",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraIssueSearchViewResult"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v157/*: any*/),
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": (v159/*: any*/),
                            "concreteType": "JiraIssueSearchViewConfigSettings",
                            "kind": "LinkedField",
                            "name": "viewConfigSettings",
                            "plural": false,
                            "selections": [
                              (v160/*: any*/),
                              (v161/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v38/*: any*/),
                          (v162/*: any*/),
                          {
                            "args": (v163/*: any*/),
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                              (v76/*: any*/),
                              {
                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueSearchFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v61/*: any*/),
                                      (v60/*: any*/),
                                      (v164/*: any*/),
                                      (v165/*: any*/),
                                      (v166/*: any*/),
                                      (v167/*: any*/),
                                      (v168/*: any*/),
                                      (v169/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v94/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v170/*: any*/),
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "args": (v159/*: any*/),
                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                    "kind": "LinkedField",
                                    "name": "viewConfigSettings",
                                    "plural": false,
                                    "selections": [
                                      (v171/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraIssueSearchView"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "args": (v173/*: any*/),
                                "concreteType": "JiraIssueSearchViewConfigSettings",
                                "kind": "LinkedField",
                                "name": "viewSettings",
                                "plural": false,
                                "selections": [
                                  (v171/*: any*/),
                                  (v174/*: any*/),
                                  (v160/*: any*/),
                                  (v161/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraSpreadsheetView",
                            "abstractKey": "__isJiraSpreadsheetView"
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isJiraIssueSearchViewMetadata"
                              },
                              (v38/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": (v159/*: any*/),
                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                    "kind": "LinkedField",
                                    "name": "viewConfigSettings",
                                    "plural": false,
                                    "selections": [
                                      (v171/*: any*/),
                                      (v175/*: any*/),
                                      (v176/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "JiraIssueSearchView"
                              },
                              (v178/*: any*/)
                            ]
                          },
                          (v94/*: any*/)
                        ],
                        "type": "JiraIssueSearchViewMetadata",
                        "abstractKey": "__isJiraIssueSearchViewMetadata"
                      }
                    ],
                    "type": "JiraIssueSearchView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v98/*: any*/),
                      (v179/*: any*/)
                    ],
                    "type": "QueryError"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v93/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v27/*: any*/),
                  (v51/*: any*/),
                  (v30/*: any*/),
                  (v53/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "viewConfigInput",
                    "variableName": "staticViewInput"
                  },
                  (v54/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "jiraIssueSearchView",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isJiraView"
                  },
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "error",
                    "plural": false,
                    "selections": (v180/*: any*/)
                  },
                  (v38/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v157/*: any*/),
                      {
                        "args": (v163/*: any*/),
                        "concreteType": "JiraIssueSearchFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "JiraIssueSearchViewMetadata",
                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v173/*: any*/),
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                          (v175/*: any*/),
                          (v176/*: any*/),
                          {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "groupByField",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  (v38/*: any*/),
                                  (v57/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                  }
                                ]
                              }
                            ]
                          },
                          (v160/*: any*/),
                          (v161/*: any*/)
                        ]
                      },
                      (v152/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "filterId"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v162/*: any*/),
                          {
                            "args": (v163/*: any*/),
                            "concreteType": "JiraIssueSearchFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                              (v76/*: any*/),
                              {
                                "concreteType": "JiraIssueSearchFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueSearchFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v60/*: any*/),
                                      (v164/*: any*/),
                                      (v165/*: any*/),
                                      (v166/*: any*/),
                                      (v167/*: any*/),
                                      (v169/*: any*/),
                                      (v168/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v94/*: any*/)
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "args": (v159/*: any*/),
                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                    "kind": "LinkedField",
                                    "name": "viewConfigSettings",
                                    "plural": false,
                                    "selections": (v177/*: any*/)
                                  }
                                ],
                                "type": "JiraIssueSearchView"
                              },
                              (v178/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v170/*: any*/),
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "args": (v159/*: any*/),
                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                    "kind": "LinkedField",
                                    "name": "viewConfigSettings",
                                    "plural": false,
                                    "selections": [
                                      (v160/*: any*/),
                                      (v171/*: any*/),
                                      (v161/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraIssueSearchView"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "args": (v173/*: any*/),
                                "concreteType": "JiraIssueSearchViewConfigSettings",
                                "kind": "LinkedField",
                                "name": "viewSettings",
                                "plural": false,
                                "selections": [
                                  (v161/*: any*/),
                                  (v171/*: any*/),
                                  (v174/*: any*/),
                                  (v160/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraSpreadsheetView",
                            "abstractKey": "__isJiraSpreadsheetView"
                          },
                          (v94/*: any*/)
                        ],
                        "type": "JiraIssueSearchViewMetadata",
                        "abstractKey": "__isJiraIssueSearchViewMetadata"
                      }
                    ],
                    "type": "JiraSpreadsheetView",
                    "abstractKey": "__isJiraSpreadsheetView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v181/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/),
                              (v139/*: any*/),
                              (v37/*: any*/),
                              (v94/*: any*/),
                              (v141/*: any*/)
                            ]
                          },
                          (v144/*: any*/),
                          (v145/*: any*/),
                          (v149/*: any*/),
                          (v150/*: any*/),
                          (v151/*: any*/),
                          (v152/*: any*/),
                          (v153/*: any*/),
                          (v94/*: any*/),
                          (v154/*: any*/)
                        ]
                      },
                      {
                        "args": (v181/*: any*/),
                        "filters": (v156/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorDetailedViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ],
                    "type": "JiraDetailedView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v182/*: any*/),
                        "concreteType": "JiraSpreadsheetGroupConnection",
                        "kind": "LinkedField",
                        "name": "groups",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraSpreadsheetGroupEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v36/*: any*/),
                              {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v152/*: any*/),
                                  (v42/*: any*/),
                                  (v183/*: any*/),
                                  (v184/*: any*/),
                                  (v185/*: any*/)
                                ]
                              },
                              (v37/*: any*/)
                            ]
                          },
                          (v144/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "groupByField"
                          },
                          (v152/*: any*/),
                          {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": (v180/*: any*/)
                          },
                          {
                            "condition": "isPaginating",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "firstGroup",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/),
                                  (v152/*: any*/),
                                  (v184/*: any*/),
                                  (v183/*: any*/),
                                  (v185/*: any*/),
                                  {
                                    "args": (v186/*: any*/),
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          (v37/*: any*/),
                                          (v36/*: any*/),
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v37/*: any*/),
                                              (v38/*: any*/),
                                              (v39/*: any*/),
                                              (v40/*: any*/),
                                              (v41/*: any*/),
                                              (v46/*: any*/),
                                              (v48/*: any*/),
                                              (v50/*: any*/),
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  (v137/*: any*/),
                                                  {
                                                    "condition": "shouldQueryFieldSetsById",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                      {
                                                        "args": (v55/*: any*/),
                                                        "concreteType": "JiraIssueFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSetsForIssueSearchView",
                                                        "plural": false,
                                                        "selections": (v136/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v94/*: any*/),
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "args": (v140/*: any*/),
                                                "concreteType": "JiraIssueFieldSetConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldSets",
                                                "plural": false,
                                                "selections": (v136/*: any*/),
                                                "storageKey": "fieldSets(first:500)"
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v150/*: any*/),
                                      (v153/*: any*/),
                                      {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                          (v142/*: any*/),
                                          (v143/*: any*/)
                                        ]
                                      },
                                      (v94/*: any*/),
                                      (v154/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": (v186/*: any*/),
                                    "filters": [
                                      "fieldSetsInput"
                                    ],
                                    "handle": "connection",
                                    "key": "firstGroupSection_nativeIssueTable__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                  },
                                  (v42/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v94/*: any*/)
                        ]
                      },
                      {
                        "args": (v182/*: any*/),
                        "filters": (v156/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorGroupedListViewPagination__groups",
                        "kind": "LinkedHandle",
                        "name": "groups"
                      }
                    ],
                    "type": "JiraGroupedListView"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": (v187/*: any*/),
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": (v155/*: any*/)
                      },
                      {
                        "args": (v187/*: any*/),
                        "filters": (v156/*: any*/),
                        "handle": "connection",
                        "key": "IssueNavigatorListViewPagination__issues",
                        "kind": "LinkedHandle",
                        "name": "issues"
                      }
                    ],
                    "type": "JiraListView"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c87dc483b646067310ffb71a20f2a44bc95f5eac4ea747c3f0a2c40f77ba4dfd",
    "metadata": {},
    "name": "IssueNavigatorIssueSearchRefetchQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "isRefactorNinToViewSchemaEnabled": isRefactorNinToViewSchemaEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": isRefactorNinToViewSchemaEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": bulkOpsInNinEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": isJscInfiniteScrollEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "df75ebbabf681ee8b6dc5d51605996ca";

export default node;
